module.exports = __webpack_public_path__ + "static/media/Medical translation service.cf2973bd.png";